export const OidcSettings = {
  authority: 'https://auth.bandeirantes.digital',
  client_id: 'f29959b8e41f45b1882c7044440bd046',
  responseType: 'id_token token',
  signInScheme: 'cookie',
  redirect_uri: 'http://portalcomercial-hmlg.bandeirantes.com.br/signin-oidc',
  scope: 'openid comercial',
  response_mode: 'form_post',
  post_logout_redirect_uri: 'http://portalcomercial-hmlg.bandeirantes.com.br'
};
